import axios from '@/axios.js';

export default {
  methods: {
    getSocialPlaceholder(value) {
      switch (true) {
        case value == 'whatsapp':
          return this.$t('harmony.whatsapp-label')
        case value == 'email':
          return this.$t('harmony.mail-label')
        default:
          return this.$t('harmony.enter-username')
      }
    },

    getIconSize() {
      const count = this.countSocials();
      if (count <= 2) {
        return 'icon-size-large';
      } else if (count <= 3) {
        return 'icon-size-medium';
      } else if (count <= 4) {
        return 'icon-size-small';
      } else {
        return 'icon-size-smallest';
      }
    },

    async saveSocial(item) {
      this.loadingSave = true;
      const response = await axios.post('save-social', { social: item, site_id: this.harmony.id })
      if (Object.prototype.hasOwnProperty.call(this.changes, item.name)) {
        this.changes[item.name] = false;
      }
      if (response.data) {
        this.dialog = false
        this.$vs.notify({
          title: this.$t('harmony.social-saved-title'),
          text: this.$t('harmony.social-saved-text'),
          color: 'success',
          icon: 'check_box',
          position: 'bottom-center',
          time: 5000,
        })
      }
      this.loadingSave = false;
      const slug = this.$route.params.slug;
      this.loadHarmony(slug);
    },

    async deleteSocial(item) {
      this.loadingSave = true;
      const response = await axios.post('remove-social', { social: item, site_id: this.harmony.id })
      if (response.data) {
        this.dialog = false
        this.$vs.notify({
          title: this.$t('harmony.social-deleted-title'),
          text: this.$t('harmony.social-deleted-text'),
          color: 'success',
          icon: 'check_box',
          position: 'bottom-center',
          time: 5000,
        })
      }
      this.loadingSave = false;
      const slug = this.$route.params.slug;
      this.loadHarmony(slug);
    },

    async getSocials() {
      try {
        const response = await axios.get('get-socials');
        this.list_socials = response.data;
        if (this.countSocials() < 0) {
          const socialNames = this.defaultSocials.map(social => social.name.toLowerCase());
          this.list_socials = this.list_socials.filter(item => !socialNames.includes(item.value.toLowerCase()));
        }
      } catch (error) {
        console.log(error);
      }
    },

    setSocialStyle(value) {
      if (!this.loadingSave) {
        this.selectedSocial = value;
        this.site_setting.style_socials = value
        this.saveSettings()
      }
    },

    getSocialStyle(value) {
      return this.$t('harmony.style') + value
    },

    getIconPath(social) {
      return `https://backend.harmony.fan/storage/socials/${this.site_setting.style_socials}/${social}.svg`;
    },

    getSocialIconLink(name) {
      const ss = this.usedSiteSetting || this.site_setting;
      const style = ss?.style_socials;
      if (style === 'default') {
        return `https://backend.harmony.fan/storage/socials/default/${name}.svg`;
      }
      if (typeof style === 'object') {
        return `https://backend.harmony.fan/storage/socials/no-styles/${name}.png`;
      }
      return `https://backend.harmony.fan/storage/socials/${style}/${name}.svg`;
    },

    hasSocialsError() {
      if (!this.incomplete_configurations || this.incomplete_configurations.length === 0) {
        return false;
      }
      return this.incomplete_configurations.some(config =>
        this.isErrorFromSocials(config)
      );
    },

    getSocialsError() {
      if (!this.incomplete_configurations || this.incomplete_configurations.length === 0) {
        return null;
      }
      const error = this.incomplete_configurations.find(config =>
        this.isErrorFromSocials(config)
      );
      return error || null;
    },

    isErrorFromSocials(config) {
      const platformName = config.name.toLowerCase();
      if (config.type === 'instagram_not_found') {
        const isInSocials = this.socials.some(social =>
          social.name.toLowerCase() === platformName
        );
        if (isInSocials) {
          return true;
        }
      }
      return false;
    },

    countSocials() {
      return this.socials.length
    }
  }
}
